import { createFormDataRequest } from "@/helpers/FormHelpers";
import { IFilters, IPaginateResponse } from "@/interfaces/Fetch";
import Organisation, {
  OgranisationForm,
  UpdateOrganisationForm,
} from "@/interfaces/Organisation";
import api from "./api";

export const organisationsApi = api.injectEndpoints({
  endpoints: (builds) => ({
    getOrganisations: builds.query<IPaginateResponse<Organisation>, IFilters>({
      query: (params) => ({
        url: "/organisations",
        params,
      }),
      providesTags: (result, _error, _arg) =>
        result
          ? [
              ...result.data.map(({ id }) => ({
                type: "Organisations" as const,
                id,
              })),
              { type: "Organisations", id: "LIST" },
            ]
          : [{ type: "Organisations", id: "LIST" }],
    }),
    getOrganisation: builds.query<Organisation, string>({
      query: (id) => ({
        url: `/organisations/${id}`,
      }),
      providesTags: (_result, _error, id) => [{ type: "Organisations", id }],
    }),
    storeOrganisation: builds.mutation<Organisation, OgranisationForm>({
      query: (data) => {
        const body = createFormDataRequest(data);

        return {
          url: `/organisations`,
          method: "POST",
          body,
        };
      },
      invalidatesTags: [{ type: "Organisations", id: "LIST" }],
    }),
    updateOrganisation: builds.mutation<
      Organisation,
      { id: string; data: UpdateOrganisationForm }
    >({
      query: ({ id, data }) => {
        const body = createFormDataRequest(data);

        return {
          url: `/organisations/${id}`,
          method: "PUT",
          body,
        };
      },
      invalidatesTags: (_result, _error, { id }) => [
        { type: "Organisations", id },
        { type: "Organisations", id: "LIST" },
      ],
    }),
    deleteOrganisation: builds.mutation<void, string>({
      query: (id) => ({
        url: `/organisations/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: [{ type: "Organisations", id: "LIST" }],
    }),
  }),
  overrideExisting: true,
});

export const {
  useDeleteOrganisationMutation,
  useGetOrganisationsQuery,
  useGetOrganisationQuery,
  useStoreOrganisationMutation,
  useUpdateOrganisationMutation,
  useLazyGetOrganisationsQuery,
  useLazyGetOrganisationQuery,
} = organisationsApi;
